// Runtime URL composition helpers tied to the deployed environment.
//
// Pure utility functions live under `src/utils/`:
//   - `utils/videoUtils.ts`   — YouTube embed URL conversion
//   - `utils/localeUtils.ts`  — BCP-47 locale formatting
//   - `utils/coveoUtils.ts`   — Coveo field names + facet hash URLs
// The named re-exports at the bottom keep existing call sites working while
// the codebase migrates to the topical imports.

export function getBaseUrl(host?: string | null): string {
  if (host) {
    const protocol = process.env.NODE_ENV === "development" ? "http" : "https";
    return `${protocol}://${host}`;
  }
  return (
    process.env.NEXT_PUBLIC_SITE_URL ||
    process.env.NEXT_PUBLIC_BASE_URL ||
    "http://localhost:3000"
  );
}

export function getFullUrl(path: string, host?: string | null): string {
  const baseUrl = getBaseUrl(host);
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  return `${baseUrl}${cleanPath}`;
}

// --- backward-compat re-exports (prefer importing from `utils/*` directly) ---
export { capitalizeLanguageRegion } from "../utils/localeUtils";
export { convertToEmbedUrl } from "../utils/videoUtils";
export { encodeHashValue, buildHashUrl } from "../utils/coveoUtils";
